import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import React, { useLayoutEffect } from 'react';
import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
import { IconButton } from 'src/components';
import { pixelScaler } from 'src/themes/Metrics';
import { TripDetailModal } from '../../components/layout/TripDetailModal';

const ConfirmPaymentView = React.lazy(() => import('./ConfirmPaymentView'));

const ConfirmPaymentScreen = (props: any) => {
  const navigation = useNavigation();
  const { departureTripInfo, returnTripInfo } = useTripInfoState();
  const [isVisible, setVisible] = React.useState(false);
  // const { params } = useRoute<RouteProp<DashboardStackParams, 'SelectSeatScreen'>>();

  console.log({ departureTripInfo });

  useLayoutEffect(() => {
    const selectSeatHeaderRight = () => (
      <IconButton
        icon={<Ionicons name="information-circle-outline" size={pixelScaler(24)} color="white" />}
        onPress={() => {
          setVisible(true);
        }}
      />
    );

    navigation.setOptions({
      headerRight: selectSeatHeaderRight,
    });
  }, []);

  const handleClose = () => setVisible(false);

  return (
    <React.Suspense>
      <ConfirmPaymentView {...props} />
      {isVisible && (
        <TripDetailModal
          isVisible={isVisible}
          onClose={handleClose}
          returnTripId={returnTripInfo?.tripId}
          departureTripId={departureTripInfo?.tripId}
        />
      )}
    </React.Suspense>
  );
};

export default ConfirmPaymentScreen;
